(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-video-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.cpCardVideoPreviewInstalled) return;
    window.cpCardVideoPreviewInstalled = true;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const touchLayout = window.matchMedia('(max-width: 760px), (hover: none)');
    const states = new WeakMap();
    let active = null;
    let pointer = null;
    const markerFor = (target) => target instanceof Element ? (target.closest('.product-card__media') || target.closest('a')?.querySelector('.product-card__media'))?.querySelector('[data-cp-card-video]') : null;
    const stateFor = (marker) => {
      if (!marker) return null;
      if (!states.has(marker)) {
        const link = marker.closest('a');
        if (!link || (!marker.dataset.videoSrc && !marker.dataset.videoId)) return null;
        const state = { marker, link, video: null, frame: null, timer: null, version: 0, failed: false, baseLabel: link.getAttribute('aria-label') };
        states.set(marker, state);
      }
      return states.get(marker);
    };
    const label = (state, text) => state.link.setAttribute('aria-label', [state.link.closest('.product-card')?.querySelector('.product-card__title')?.textContent.trim(), text].filter(Boolean).join('. '));
    const stop = () => {
      if (!active) return;
      const state = active;
      active = null;
      state.version += 1;
      clearTimeout(state.timer);
      state.marker.classList.remove('cp-card-video--active', 'cp-card-video--playing', 'cp-card-video--touch');
      if (state.video) {
        state.video.pause();
        state.video.removeAttribute('src');
        state.video.load();
      }
      if (state.frame) { state.frame.remove(); state.frame = null; }
      if (state.baseLabel === null) state.link.removeAttribute('aria-label');
      else state.link.setAttribute('aria-label', state.baseLabel);
    };
    const fail = (state, version) => {
      if (active !== state || state.version !== version) return;
      stop();
      state.failed = true;
      state.marker.classList.add('cp-card-video--failed');
    };
    const start = (state, mode) => {
      if (!state || state.failed || document.hidden || active === state) return;
      stop();
      active = state;
      const version = ++state.version;
      state.marker.classList.add('cp-card-video--active');
      state.marker.classList.toggle('cp-card-video--touch', mode !== 'mouse');
      label(state, state.marker.dataset.openLabel);
      if (!state.marker.dataset.videoSrc) {
        const host = state.marker.dataset.videoHost;
        const id = state.marker.dataset.videoId;
        let url;
        if (host === 'youtube' && /^[A-Za-z0-9_-]{11}$/.test(id)) url = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=1&playsinline=1&controls=0&loop=1&playlist=${id}&rel=0`;
        else if (host === 'vimeo' && /^\d+$/.test(id)) url = `https://player.vimeo.com/video/${id}?autoplay=1&muted=1&loop=1&background=1&dnt=1`;
        else { fail(state, version); return; }
        const frame = document.createElement('iframe');
        frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        frame.setAttribute('title', state.marker.dataset.previewLabel);
        frame.setAttribute('aria-hidden', 'true');
        frame.setAttribute('tabindex', '-1');
        frame.onload = () => {
          if (active !== state || state.version !== version) return;
          clearTimeout(state.timer);
          state.marker.classList.add('cp-card-video--playing');
        };
        frame.onerror = () => fail(state, version);
        frame.src = url;
        state.frame = frame;
        state.marker.prepend(frame);
        state.timer = setTimeout(() => fail(state, version), 12000);
        return;
      }
      if (!state.video) {
        const video = document.createElement('video');
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'none';
        video.setAttribute('aria-hidden', 'true');
        video.setAttribute('tabindex', '-1');
        state.marker.prepend(video);
        state.video = video;
      }
      const video = state.video;
      video.onplaying = () => {
        if (active !== state || state.version !== version) return;
        clearTimeout(state.timer);
        state.marker.classList.add('cp-card-video--playing');
      };
      video.onerror = () => fail(state, version);
      video.src = state.marker.dataset.videoSrc;
      state.timer = setTimeout(() => fail(state, version), 12000);
      const result = video.play();
      if (result && result.catch) result.catch(() => fail(state, version));
    };
    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse' || reducedMotion.matches || touchLayout.matches) return;
      const marker = markerFor(event.target);
      if (!marker || marker.closest('.product-card__media').contains(event.relatedTarget)) return;
      start(stateFor(marker), 'mouse');
    });
    document.addEventListener('pointerout', (event) => {
      if (event.pointerType !== 'mouse' || !active) return;
      const media = active.marker.closest('.product-card__media');
      if (media.contains(event.target) && !media.contains(event.relatedTarget)) stop();
    });
    document.addEventListener('pointerdown', (event) => {
      const marker = markerFor(event.target);
      if (active && marker !== active.marker) stop();
      pointer = { type: event.pointerType, marker, x: event.clientX, y: event.clientY, moved: false, at: Date.now() };
    }, { passive: true });
    document.addEventListener('pointermove', (event) => {
      if (!pointer || pointer.type !== 'touch') return;
      if (Math.abs(event.clientX - pointer.x) + Math.abs(event.clientY - pointer.y) > 12) pointer.moved = true;
    }, { passive: true });
    document.addEventListener('pointercancel', () => { pointer = null; stop(); }, { passive: true });
    document.addEventListener('click', (event) => {
      const marker = markerFor(event.target);
      const state = stateFor(marker);
      if (!state || state.failed || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.detail === 0) return;
      const touch = touchLayout.matches || event.pointerType === 'touch' || (pointer?.type === 'touch' && pointer.marker === marker && Date.now() - pointer.at < 1500);
      if (!touch) return;
      if (pointer?.moved) { event.preventDefault(); return; }
      if (active === state) { stop(); return; }
      event.preventDefault();
      start(state, 'touch');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { stop(); return; }
      if (event.key !== ' ') return;
      const state = stateFor(markerFor(event.target));
      if (!state || state.failed) return;
      event.preventDefault();
      if (active === state) stop();
      else start(state, 'keyboard');
    });
    document.addEventListener('focusin', (event) => {
      const state = stateFor(markerFor(event.target));
      if (state && !state.failed && active !== state) label(state, state.marker.dataset.previewLabel);
    });
    document.addEventListener('focusout', (event) => {
      if (active?.link === event.target) stop();
    });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
    document.addEventListener('shopify:section:unload', stop);
    window.addEventListener('pagehide', stop);
    window.addEventListener('scroll', () => { if (active?.marker.classList.contains('cp-card-video--touch')) stop(); }, { passive: true });
    window.addEventListener('blur', stop);
    window.addEventListener('resize', stop);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => { for (const entry of entries) if (!entry.isIntersecting && active?.marker === entry.target) stop(); });
      const observe = () => document.querySelectorAll('[data-cp-card-video]').forEach((marker) => observer.observe(marker));
      observe();
      new MutationObserver(() => { if (active && !active.marker.isConnected) stop(); observe(); }).observe(document.body, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
